// @flow
import React, { Component } from 'react';
import { Navigate } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import LoginStore from '../../../store/LoginStore';
import Loading from '../Shared/Loading';

type Props = {
  LoginStore: typeof LoginStore;
};

type State = {
  errorMessage: string | null;
  loading: boolean;
  noCustomership: boolean;
};

class ManagerLogin extends Component<Props, State> {
  state: State = {
    errorMessage: null,
    loading: true,
    noCustomership: true,
  };

  componentDidMount = async () => {
    const response = await LoginStore.login('company');

    if (!response || response.status === 204) {
      sessionStorage.clear();
      this.setState({
        errorMessage:
          ' Käyttäjätietoja ei löydetty. Ongelmatilanteen jatkuessa ota yhteyttä asiakaspalveluun.',
        loading: false,
        noCustomership: true,
      });
    }
    if (response && response.status === 408) {
      sessionStorage.clear();
      this.setState({
        errorMessage:
          'Taustajärjestelmissä huoltokatko, kulutustiedot eivät ole saatavilla. Yritä myöhemmin uudestaan',
        loading: false,
        noCustomership: true,
      });
    } else if (response && response.status === 401) {
      sessionStorage.clear();
      this.setState({
        errorMessage: 'Väärä sähköposti tai salasana',
        loading: false,
        noCustomership: true,
      });
    } else if (response && response.status === 403) {
      sessionStorage.clear();
      this.setState({
        errorMessage:
          'Kirjautuminen epäonnistui. Virhe asiakkuustietoja hakiessa. Ota yhteyttä asiakaspalveluun.',
        loading: false,
        noCustomership: true,
      });
    } else if (response && response.ok) {
      this.setState({
        errorMessage: '',
        loading: false,
        noCustomership: true,
      });
    }
  };

  render() {
    const { LoginStore } = this.props;
    const { loading, errorMessage, noCustomership } = this.state;

    if (loading) {
      return <Loading message="Ladataan tietoja..." />;
    }

    if (LoginStore.type === 'companyManager') {
      return <Navigate to="/yritys/yleisnakyma"/>;
    }
    if (LoginStore.type === 'companyUser') {
      return <Navigate to="/yritys/yleisnakyma"/>;
    }

    if (errorMessage) {
      const hostName = window.location.origin;
      const logoutUrl = '/oauth/logout?redirect=' + hostName;
      return (
        <>
          <div style={{ height: '30vh', padding: '3rem' }}>
            {errorMessage}
            {noCustomership && (
              <a
                style={{ display: 'block', marginTop: '2rem' }}
                href={logoutUrl}
              >
                Kirjaudu ulos
              </a>
            )}
          </div>
        </>
      );
    }

    return <Navigate to="/yritys/yleisnakyma"/>;
  }
}

export default inject('LoginStore')(observer(ManagerLogin));
